'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /** @jsx dom */


var _url = require('@viskan/streamline-utilities/lib/url');

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _lodash = require('lodash.omit');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var name = 'Link';

var defaultProps = {
	autoPrefix: true
};

var propTypes = {
	autoPrefix: {
		type: 'boolean'
	},
	children: {
		type: 'array'
	},
	countryCode: {
		type: 'string'
	},
	dispatch: {
		type: 'function'
	},
	languageCode: {
		type: 'string'
	},
	localeMode: {
		type: 'string'
	},
	prefix: {
		type: 'string'
	}
};

var getHref = function getHref(props) {
	if (props.href) {
		var prefix = props.prefix || (0, _url.getLocaleFriendlyPathPrefix)(props.languageCode, props.countryCode, props.localeMode);

		return (0, _url.getLocaleFriendlyPath)(props.href, props.localeMode, prefix);
	}

	return props.href;
};

var render = function render(_ref) {
	var props = _ref.props;

	var propsToUse = (0, _lodash2.default)(props, Object.keys(propTypes));

	if (!props.prefix && !props.countryCode && !props.languageCode && !props.localeMode) {
		return (0, _magicVirtualElement2.default)(
			'a',
			_extends({}, propsToUse, { 'class': [name, props.class] }),
			props.children
		);
	}

	return (0, _magicVirtualElement2.default)(
		'a',
		_extends({}, propsToUse, { lang: props.languageCode, 'class': [name, props.class], href: getHref(props) }),
		props.children
	);
};

exports.default = { defaultProps: defaultProps, name: name, propTypes: propTypes, render: render };